import { axios } from "@LIBS";
import { Constants } from "@CONFIG";

const UserEndpoints = {
  getAll: "api/admin/users",
};

/*
const createDelivery = async (values) => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/delivery`,
    method: 'POST',
    data: values,
  });

  return response;
};
*/

const changePassword = async (values) => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/auth/changePassword`,
    method: "POST",
    data: values,
  });

  return response;
};

export { UserEndpoints, changePassword };
